export const RNScreenBrightness = {
  setBrightness: async () => {},
  getBrightness: async () => {},
};
